module.exports = __webpack_public_path__ + "static/media/outland_denim_jeans_measuring.c2326a94.png";